var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEnabled)?_c('div',{staticClass:"custom-cursor-container",class:{
    'cursor--hidden': !_vm.isVisible,
    'cursor--hover': _vm.isHovered,
    'cursor--click': _vm.isClicked,
  }},[_c('div',{ref:"follower",staticClass:"custom-cursor-follower"}),_c('div',{ref:"dot",staticClass:"custom-cursor-dot"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }